import * as React from 'react';
import styled from 'styled-components';
import { useTransitionState } from "react-transition-state";

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { Pane } from './Pane';

type TModeMap = { [key: string]: React.ComponentType  };

const ANIMATION_DURATION = 0.5; // Animation duration in seconds.

interface IProps {
  modeMap: TModeMap;
}

const PaneController = (props: IProps) => {
  const globalState = useGlobalState();

  const [component, setComponent] = React.useState<React.ReactElement | null>(null);

  const [{ status, isMounted, isEnter }, toggle] = useTransitionState({
    timeout: ANIMATION_DURATION * 1000,
    mountOnEnter: true,
    initialEntered: false,
    preEnter: true,
    unmountOnExit: true,
  });  

  // When the global mode changes, we check if there's anything to show in
  // the panel. If there is, we open the panel; otherwise we close it.
  // When the panel closes, we keep track of the last shown thing so that 
  // it can continue to be rendered until the panel is closed and it 
  // unmounts.
  React.useEffect(() => {
    const mode = globalState.mode;
    if(mode != null && Object.keys(props.modeMap).includes(mode)) {
      const Comp = props.modeMap[mode];
      setComponent(<Comp/>);
      toggle(true);
    } else {
      toggle(false);
    }
  }, [globalState.mode]);

  return (
    <PaneHolder className={status}>
      {isMounted && (
        <Pane>
          <PaneContent>
            {component}
          </PaneContent>        
        </Pane>
      )}
    </PaneHolder>
  )
}

const PaneContent = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;    
`

const PaneHolder = styled.div`
  position: absolute;
  left: 80px;
  top: 0;
  bottom: 0;
  z-index: 101;

  /* useTransitionState classes */
  transition: opacity ${ANIMATION_DURATION}s ease;
  opacity: 0;
  &.preEnter, &.exiting {
    opacity: 0;
  }
  &.entering {
    opacity: 1;
  }
  &.entered {
    opacity: 1;
  }
  &.unmounted {
    // Must remove, or map cannot be clicked.
    display: none;
  }
  
`

export { PaneController }
